import React from 'react';
import BaseParameters from '..';

function RevenueParameters() {
    return (
        <BaseParameters paramGroup="Revenue Parameters"/>
    );
}

export default RevenueParameters;
